import { useMemo } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { computeVatNumber } from '../../../../companies/utils/computeVatNumber'
import { useZervantSettings } from '../../../hooks/useZervantSettings'
import { getDefaultLegalStatusValues } from '../../../utils/getDefaultLegalStatusValues'
import { getPrimaryTradeName } from '../../../utils/getPrimaryTradeName'

export const usePredefinedCompanyInformationValues = () => {
  const { data: zervantSettings, isLoading: isLoadingZervantSettings } = useZervantSettings()
  const { organization, isLoading: isLoadingUserOrganization } = useUserOrganization()
  const isLoading = isLoadingZervantSettings || isLoadingUserOrganization

  const defaultLegalStatusFields = useMemo(() => getDefaultLegalStatusValues(zervantSettings), [zervantSettings])

  const predefinedCompanyInformationFormValues = useMemo(() => {
    const defaultTradeName = getPrimaryTradeName(zervantSettings?.values.company.tradeNames)
    if (!zervantSettings || !organization) {
      return
    }

    const computedVatNo =
      organization.vatNo || organization.isVatExempted
        ? undefined
        : (computeVatNumber(organization.countryId, organization.registrationNo) ?? undefined)

    return {
      addressLine2: organization?.addressLine2,
      ...(computedVatNo && { autoCompletedFields: { vatNo: true } }),
      companyAddress: organization?.street,
      companyCity: organization?.city,
      companyName: organization?.name,
      companyZipCode: organization?.zipcode,
      contactEmail: defaultTradeName?.contact?.email,
      contactFirstName: defaultTradeName?.contact?.name?.first,
      contactLastName: defaultTradeName?.contact?.name?.last,
      contactPhone: defaultTradeName?.contact?.phone,
      isSiretPendingAssignment: zervantSettings?.values?.company?.legalFormSettings?.isSiretPendingAssignment,
      isVatExempted: organization?.isVatExempted,
      legalStatusCustom: defaultLegalStatusFields.legalStatusCustom,
      legalStatusOption: defaultLegalStatusFields.legalStatusOption,
      registrationNo: organization?.registrationNo,
      sharedCapital: defaultLegalStatusFields.sharedCapital,
      vatNo: organization.vatNo || computedVatNo,
    }
  }, [organization, zervantSettings, defaultLegalStatusFields])

  return { predefinedCompanyInformationFormValues, isLoading }
}
